(function() {
    'use strict';
    Odigeo.UIElements.enhanceSwitcher = function($select, newoptions) {
        // Init object with default options
        var options;
        var handler;
        var _toggleEnabled;
        var _toggleDisableItems;
        var _tapHandler;
        var _setActiveTab;
        var _toogleSelectedSwitcher;
        var $wrapper;
        var $ul;
        var $tooltip;
        var $switcherTab;

        if ($select.attr('data-skip-enhance') === 'true') {
            return $select;
        }
        $select.attr({'data-skip-enhance': true});

        options = {
            style: 'od-ui-switcher',
            enabled: true,
            hideHintTimeout: 50000,
            button: true,
        };

        options = Odigeo._.extend(options, $select.data(), newoptions);

        $wrapper = $('<div>', {'class': 'switcher'});

        if (!options.enabled || $select.is('[disabled]')) {
            $wrapper.addClass('disabled');
        }
        if (Odigeo._.has(options, 'tabindex')) {
            $wrapper.attr('tabindex', options.tabindex);
        }

        switch ($select.attr('data-role')) {
            case 'switcher':
                $wrapper.addClass(options.style);
                $select.replaceWith($wrapper);
                $wrapper.append($select.hide());
                $ul = $('<ul>', {'class': 'od-ui-switcher-tabs'}).appendTo($wrapper);

                $.each($select.children('option'), function(index, option) {
                    // Tooltip hint creation
                    if (option.getAttribute('data-hint') !== null) {
                        $tooltip = $('<div>', {'class': 'switcher_hint_tooltip od-ui-switcher-tooltip hidden'})
                            .append($('<div>', {'class': 'tooltip-arrow-border'}))
                            .append($('<div>', {'class': 'tooltip-arrow'}))
                            .append($('<div>', {'class': 'tooltip-content'})
                                .append($('<div>', {
                                    'class': 'od-ui-switcher-tooltip-primary-text',
                                    'text': option.getAttribute('data-hint'),
                                }))
                                .append(!Odigeo._.isNull(option.getAttribute('data-hint-secondary')) ?
                                    $('<div>', {
                                        'class': 'od-ui-switcher-tooltip-secondary-text',
                                        'text': option.getAttribute('data-hint-secondary'),
                                    }) :
                                    $())
                            );
                    }

                    // Switcher creation
                    $ul.append(
                        $('<li>', {
                            'class': 'od-ui-switcher-tab switcher_tab wl-bookingcom-text' + (option.selected ? ' active' : ''),
                            'data-value': option.value,
                        }).append(
                            $('<span>', {
                                'class': 'switcher_label ' + (option.getAttribute('data-icon') !== null ? 'ficon' : 'od-ui-switcher-label'),
                                'html': option.innerHTML,
                            })
                        ).append($tooltip)
                    );
                });
                break;

            case 'odf-switcher':
                $wrapper.addClass('switcher odf-btn-group-flex odf-btn-group');
                $select.replaceWith($wrapper);
                $wrapper.append($select.hide());

                $.each($select.children('option'), function(index, option) {
                    var id = $(option).data('id') || $select.attr('id') + '_' + index;
                    var inputOptions = {
                        'type': 'radio',
                        'class': 'odf-radio-btn',
                        'name': $select.attr('name') || $select.attr('id'),
                        'value': option.value,
                        'id': id,
                    };

                    if (option.selected) {
                        inputOptions.checked = 'checked';
                    }

                    // Tooltip hint creation
                    if (option.getAttribute('data-hint') !== null) {
                        $tooltip = $('<div>', {'class': 'switcher_hint_tooltip od-ui-switcher-tooltip hidden'})
                            .append($('<div>', {'class': 'tooltip-arrow-border'}))
                            .append($('<div>', {'class': 'tooltip-arrow'}))
                            .append($('<div>', {'class': 'tooltip-content'})
                                .append($('<div>', {
                                    'class': 'od-ui-switcher-tooltip-primary-text',
                                    'text': option.getAttribute('data-hint'),
                                }))
                                .append(!Odigeo._.isNull(option.getAttribute('data-hint-secondary')) ?
                                    $('<div>', {
                                        'class': 'od-ui-switcher-tooltip-secondary-text',
                                        'text': option.getAttribute('data-hint-secondary'),
                                    }) :
                                    $())
                            );
                    }

                    // Switcher creation
                    $wrapper.append(
                        $('<label>', {
                            'class': 'odf-btn odf-btn-light odf-radio-btn-label switcher_tab' + (option.selected ? ' active' : ''),
                            'data-value': option.value,
                            'for': id,
                        }).append(
                            $('<input>', inputOptions),

                            $('<span>', {'html': option.innerHTML})
                        ).append($tooltip)
                    );
                });

                if (Odigeo.Device.navigator.isIOS10) {
                    $switcherTab = $wrapper.find('.switcher_tab');
                    $switcherTab.find('span').height($switcherTab.height() - 30);
                }

                $wrapper.find('.odf-col')
                    .first().addClass('first-of-type')
                    .end()
                    .last().addClass('last-of-type');

                break;

            case 'native':
                $wrapper.addClass('od-ui-native-switcher');
                $select.addClass('od-ui-native-switcher-display').replaceWith($wrapper);
                if (options.button) {
                    $wrapper.append($('<div>', {'class': 'od-ui-native-switcher-buttonContainer'})
                        .append($('<span>', {'class': 'odf-icon odf-icon-arrow-down od-icon-arrow-down'}))
                    );
                }
                $wrapper.append($select);
                $select.show();
                break;
            default:
                break;
        }

        // Private functions
        _tapHandler = function(evt, silent) {
            if ($(this).hasClass('disabled') || $(this).closest('.switcher').hasClass('disabled')) {
                return;
            }

            // Show/hide tooltips
            $select.trigger('hideHint');
            $(this).find('.switcher_hint_tooltip').removeClass('hidden');

            _setActiveTab($(this));
            $select.val($(this).data('value'));
            Odigeo.trigger('switcher:field-action', {value: $select[0].value});
            if (!silent) {
                $select
                    .trigger('change', $select[0].value)
                    .triggerHandler('focus');
            }
        };

        _setActiveTab = function($el) {
            // odf-switch
            $el.siblings().find('.active').removeClass('active');
            $el.find('.odf-btn').addClass('active');

            $el.addClass('active').siblings().removeClass('active');
        };

        _toggleEnabled = function(enabled) {
            if (enabled) {
                $select.removeAttr('disabled');
                // show tooltip if a item of the switcher is active
                $select.trigger('hideHint');
                $select.parent().find('.active').find('.switcher_hint_tooltip').removeClass('hidden');
            } else {
                $select.attr('disabled', 'disabled');
            }

            options.enabled = enabled;
            $wrapper.toggleClass('disabled', !enabled);
        };

        _toggleDisableItems = function(items, enable) {
            var $option;
            var $tabs = $wrapper.find('.switcher_tab');
            var $targeted = $();

            items = [].concat(items);
            $.each(items, function(i, itemVal) {
                var $tab = $tabs.filter('[data-value="' + itemVal + '"]');
                $targeted = $targeted.add($tab);

                $tab.toggleClass('disabled', !enable);
                $option = $select.children('[value="' + itemVal + '"]');
                if (enable) {
                    $option.removeAttr('disabled');
                } else {
                    if ($select[0].value === $option[0].value) {
                        $select[0].value = '';
                        $select.trigger('change', $select[0].value);
                    }
                    $option.removeAttr('selected').attr('disabled', 'disabled');
                }
            });

            $tabs.not($targeted).removeClass('disabled');
        };

        _toogleSelectedSwitcher = function(ev, typeSwitcher) {
            var $selectedSwitcher = $(this).closest('.switcher').find('[data-value="' + typeSwitcher + '"]');
            $selectedSwitcher.addClass('active').siblings().removeClass('active');
        };

        // Semi-public functions
        handler = {
            enable: function() {
                Odigeo._.bind(_toggleEnabled, this, true)();
            },
            disable: function() {
                Odigeo._.bind(_toggleEnabled, this, false)();
            },
            enableItems: function(evt, items) {
                Odigeo._.bind(_toggleDisableItems, this, items, true)();
            },
            disableItems: function(evt, items) {
                Odigeo._.bind(_toggleDisableItems, this, items, false)();
            },
            hideHint: function() {
                $wrapper.find('.switcher_hint_tooltip').addClass('hidden');
            },
            setValue: function(e, value, silent) {
                switch ($select.attr('data-role')) {
                    case 'switcher':
                    case 'odf-switcher':
                        $wrapper.find('[data-value="' + value + '"]').trigger(Odigeo.Events.tap, silent);
                        break;
                    default:
                        $select.val(value).trigger('change', value);
                        break;
                }
            },
            setDefault: function() {
                return $select.trigger('change', $select.val());
            },
            clearTimeout: function() {
                throw new Error('switcher.clearTimeout: NOT IMPLEMENTED');
            },
        };

        // Other bindings
        switch ($select.attr('data-role')) {
            case 'switcher':
            case 'odf-switcher':
                $wrapper.on(Odigeo.Events.tap, '.switcher_tab', _tapHandler);
                $select.on(Odigeo.Events.change, _toogleSelectedSwitcher);
                break;
        }

        $select
            .on('setValue', Odigeo._.bind(handler.setValue, this))
            .on('setDefault', Odigeo._.bind(handler.setDefault, this))
            .on('enable', Odigeo._.bind(handler.enable, this))
            .on('disable', Odigeo._.bind(handler.disable, this))
            .on('hideHint', Odigeo._.bind(handler.hideHint, this))
            .on('disableItems', Odigeo._.bind(handler.disableItems, this))
            .on('enableItems', Odigeo._.bind(handler.enableItems, this));

        return handler;
    };
}());
